import {
    MountGlazingGasket1ValueCode,
    MountKomapsFrameValueCode,
    MountMullionsCodes,
} from "../constants/mounts";

export const isMullions = (code: string) => MountMullionsCodes.includes(code);

export const isGlazingGasket = (code: string) =>
    MountGlazingGasket1ValueCode === code;

export const isKompasPrefabricated = (code: string) =>
    MountKomapsFrameValueCode === code;
